import type { UseQueryResult } from "react-query";
import { useQuery } from "react-query";

import type { TradeInConfiguration } from "@jti/rest-api-types";

import { QUERY_KEYS } from "../../../constants/queryKeys";
import { TradeInApi } from "../../../services";

export const GET_TRADE_IN_CONFIGURATION_QUERY_KEY_BASE = QUERY_KEYS.tradeInConfiguration;

export const useGetTradeInConfiguration = (): UseQueryResult<TradeInConfiguration["data"]> => {
  const tradeInApi = new TradeInApi();

  return useQuery({
    queryKey: [QUERY_KEYS.tradeInConfiguration],
    queryFn: () => tradeInApi.getConfiguration(),
    staleTime: 5000,
    retry: false,
    select: (data) => data.data,
  });
};
